// A tab navigation cannot send the `X-API-Key` middleware header, so the document is fetched with
// axios and the tab pointed at a blob. The tab opens *before* the fetch, or Safari blocks it.

const PENDING_BODY_CSS = 'margin:0;display:grid;place-items:center;height:100vh;'
    + "font:14px -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;"
    + 'color:#64748B;background:#F1F5F9';

// Revoking straight after the navigation leaves the tab blank.
const REVOKE_AFTER_MS = 60_000;

/** Open a blank tab synchronously. Returns null if the popup was blocked. */
export function openPendingTab(message, win = window) {
    const tab = win.open('', '_blank');
    if (!tab) return null;
    try {
        // `message` carries an unvalidated document number and an about:blank tab inherits this
        // origin, so markup parsed here would run as the app. Text nodes, never document.write.
        const doc = tab.document;
        doc.title = message;
        const p = doc.createElement('p');
        p.appendChild(doc.createTextNode(message));
        doc.body.setAttribute('style', PENDING_BODY_CSS);
        doc.body.appendChild(p);
    } catch {
        // The placeholder is cosmetic.
    }
    return tab;
}

/** Point a pending tab at `blob`. `blob.type` decides render-vs-download, and an axios blob
 *  carries `application/pdf`, so the endpoint's `Content-Disposition` never applies. */
export function revealBlobInTab(tab, blob, win = window) {
    const url = win.URL.createObjectURL(blob);
    tab.location.href = url;
    win.setTimeout(() => win.URL.revokeObjectURL(url), REVOKE_AFTER_MS);
    return url;
}

/** Close a pending tab whose document never arrived. */
export function closePendingTab(tab) {
    try {
        tab?.close();
    } catch {
        // Already gone.
    }
}
